import React, { Component } from 'react';
// import PropTypes from 'prop-types';

require('./dragWidth.less');

export default class DragHeightCom extends Component {
    constructor(props) {
        super(props);
        this.mouseDown = false;
    }

    bindLeftDOM = dom => {
        this.divDom = dom;
    }

    componentDidMount() {
        if (this.divDom) {
            this.clientHeight = this.divDom.clientHeight;
        }
        this.onMouseDown.call(this);
    }

    onMouseDown() {
        document.addEventListener('mousemove', e => {
            //e.stopPropagation();
            if (this.mouseDown && this.divDom) {
                // fix bug  IE  e.x !== e.clientx  ie  
                let height= this.clientHeight + (e.clientY - this.beginY);
                if (height >= this.box.clientHeight - 20 || height <= 50) {
                    this.divDom.style.height = this.divDom.clientHeight + 'px';
                } else {
                    this.divDom.style.height = height + 'px';
                }
            }
        });
        /*document.documentElement.onmousemove = e => {
      // e.preventDefault();

    };*/

        document.addEventListener('mouseup', () => {
            if (this.mouseDown) {
                this.mouseDown = false;
                if (this.divDom) {
                    this.clientHeight = this.divDom.clientHeight;
                }
                this.maskRightDom && (this.maskRightDom.style.display = 'none');
                this.maskLeftDom && (this.maskLeftDom.style.display = 'none');
    
                typeof this.props.onDragStop === 'function' && this.props.onDragStop(this.divDom?.style.height);
            }
        });
        /*document.documentElement.onmouseup = e => {

    };*/

        this.spanDom.addEventListener('mousedown', e => {
            this.beginY = e.clientY;
            this.mouseDown = true;
            // 加个遮罩 应对  iframe的情况
            this.maskRightDom && (this.maskRightDom.style.display = 'block');
            this.maskLeftDom && (this.maskLeftDom.style.display = 'block');
        });
    /*this.spanDom.onmousedown = e => {

    };*/
    }

    render() {
        let topHeight = this.props.defTopHeight|| '150px';
        let topMinHeight = this.props.topMinHeight || '50px',
            rightOverflow = this.props.rightOverflow || "auto";
        return (
            <div
                className="dragHeightCom"
                ref={box => {
                    this.box = box;
                }}
            >
                <div
                    className="dragHeightCom_top lc-drop-area"
                    style={{ height: topHeight, minHeight: topMinHeight }}
                    ref={this.bindLeftDOM}
                >
                    <div className="dragHeightCom_mask" ref={mask => { this.maskLeftDom = mask; }} />
                    {this.props.topDom}
                </div>
                <div
                    ref={span => {
                        this.spanDom = span;
                    }}
                    className="dragHeightCom_line"
                >
                    <div className="dragHeightCom_lines" />
                </div>
                <div className="dragHeightCom_bottom lc-drop-area" id="scroll_container">
                    <div className="dragHeightCom_mask" ref={mask => { this.maskRightDom = mask; }} />
                    {this.props.bottomDom}
                </div>
            </div>
        );
    }
}
